import { CircleAlert, CircleCheck, Info, TriangleAlert, type LucideIcon } from 'lucide-react';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

export type AlertVariant = 'error' | 'info' | 'success' | 'warning';

const icons: Record<AlertVariant, LucideIcon> = {
  error: CircleAlert,
  info: Info,
  success: CircleCheck,
  warning: TriangleAlert,
};

export interface AlertProps extends ComponentPropsWithoutRef<'div'> {
  children: ReactNode;
  variant?: AlertVariant;
}

export const Alert = ({ children, className = '', role, variant = 'info', ...props }: AlertProps) => {
  const Icon = icons[variant];
  return (
    <div {...props} className={`alert alert-${variant} ${className}`.trim()} role={role ?? 'alert'}>
      <Icon aria-hidden="true" />
      <div>{children}</div>
    </div>
  );
};
